import HttpClient from "@/common/boot/HttpClient"

const listarNotificacoesNaoLidas = async ({ commit }) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/pco-notificacoes/listagem/nao-lidas');
    commit('LISTAR_DADOS', response.data.data || []);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const limparEListarNotificacoesNaoLidas = async ({ commit, dispatch }) => {
  commit('LIMPAR_DADOS');
  try {
    return await dispatch('listarNotificacoesNaoLidas');
  } catch (error) {
    console.error('Erro ao atualizar notificações do módulo:', error);
  }
}

const confirmarLeitura = async ({ commit }, id) => {
  const response = await HttpClient.put(`/pco-notificacoes/${id}/confirmar-leitura`);
  commit('REMOVER_NOTIFICACAO', id);
  return response;
}

export {
  listarNotificacoesNaoLidas,
  limparEListarNotificacoesNaoLidas,
  confirmarLeitura,
}
